import cloneDeep from 'lodash/cloneDeep';
import { generateId } from './id';

/**
 * Build a fresh section instance from the schema's first preset.
 * Returns `{ type, settings, blocks }` — caller adds `id`.
 * Returns `null` if the schema has no preset to instantiate.
 */
export function createSection(type, schema) {
  const preset = schema?.presets?.[0];
  if (!preset) return null;
  return {
    type,
    settings: preset.settings ? { ...preset.settings } : {},
    blocks: preset.blocks ? cloneBlocksMap(preset.blocks) : {},
  };
}

/**
 * Deep-clone a section and regenerate its id plus all nested block ids.
 * Used for duplicateNode.
 */
export function cloneSection(section) {
  const cloned = cloneDeep(section);
  cloned.id = generateId(cloned.type);
  if (cloned.blocks) {
    for (const slotId of Object.keys(cloned.blocks)) {
      cloned.blocks[slotId] = cloned.blocks[slotId].map((b) => ({
        ...b,
        id: generateId(b.type),
      }));
    }
  }
  return cloned;
}

function cloneBlocksMap(blocks) {
  const out = {};
  for (const [slotId, instances] of Object.entries(blocks)) {
    out[slotId] = instances.map((b) => ({
      type: b.type,
      disabled: b.disabled ?? false,
      settings: b.settings ? { ...b.settings } : {},
    }));
  }
  return out;
}
